export const experienceData = [
    {
        id: 1,
        company: 'Datadynamics Pvt Ltd, Pune',
        jobtitle: 'Software Development Engineer',
        startYear: 'Sep 2024',
        endYear: ' Nov 2025'
    },
    {
        id: 2,
        company: 'Taazaa Tech Pvt Ltd, Noida',
        jobtitle: 'Associate Software Engineer',
        startYear: 'Sep 2022',
        endYear: 'Dec 2023'
    },
]
